"use strict";
var indexCtrl = require('export/controllers/indexCtrl');
var graphCtrl = require('export/controllers/graphCtrl');
var rdfCtrl = require('export/controllers/rdfCtrl');
var documentCtrl = require('export/controllers/documentCtrl');
var kulturpoolCtrl = require('export/controllers/kulturpoolCtrl');
var xmlCtrl = require('export/controllers/xmlCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('export', ['templates', 'ngFlash']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', indexCtrl]);
app.controller('graphCtrl', ['$scope', '$rootScope', '$http', 'Flash', graphCtrl]);
app.controller('rdfCtrl', ['$scope', '$rootScope', '$http', 'Flash', rdfCtrl]);
app.controller('documentCtrl', ['$scope', '$rootScope', '$http', 'Flash', documentCtrl]);
app.controller('kulturpoolCtrl', ['$scope', '$rootScope', '$http', 'Flash', kulturpoolCtrl]);
app.controller('xmlCtrl', ['$scope', '$rootScope', '$http', 'Flash', xmlCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
